<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      物流配置管理
    </div>

    <btns @exec="exec"></btns>

    <div class="ax1"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="tableSelectionChange"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column type="selection" width="60"> </el-table-column>

      <el-table-column label="物流公司" prop="logisticsName"> </el-table-column>

      <el-table-column label="联系人" prop="contactsName"> </el-table-column>

      <el-table-column label="手机号" prop="contactsPhone"> </el-table-column>

      <el-table-column label="状态" prop="state">
        <template slot-scope="scope">
          <div v-if="scope.row.state == 1">启用</div>
          <div v-if="scope.row.state == 2">禁用</div>
        </template>
      </el-table-column>

      <el-table-column label="备注" prop="remark"> </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getchakxq(scope.row)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="编辑" :visible.sync="addORUpdateVisible" width="750px"  @close="getang">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="物流公司名称">
          <el-input v-model="ruleForm.logisticsName"></el-input>
        </el-form-item>

        <el-form-item label="联系人">
          <el-input v-model="ruleForm.contactsName"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="ruleForm.contactsPhone"></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="addORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click="gteditLogistics">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增" :visible.sync="addORUpdateVisible2" width="750px"  @close="getang">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="物流公司名称">
          <el-input v-model="ruleForm.logisticsName"></el-input>
        </el-form-item>

        <el-form-item label="联系人">
          <el-input v-model="ruleForm.contactsName"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="ruleForm.contactsPhone"></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="addORUpdateVisible2 = false">取消</el-button>
        <el-button type="primary" @click="checkClue">确定添加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="addORUpdateVisible1" width="750px"  >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="物流公司名称">
          <el-input
            :disabled="true"
            v-model="ruleForm.logisticsName"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系人">
          <el-input :disabled="true" v-model="ruleForm.contactsName"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input
            :disabled="true"
            v-model="ruleForm.contactsPhone"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input
            :disabled="true"
            type="textarea"
            v-model="ruleForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },

  data() {
    return {
      tableSelection: [],
      addORUpdateVisible2: false,
      ruleForm: {
        contactsName: "",
        contactsPhone: "",
        logisticsId: "",
        logisticsName: "",
        remark: "",
      },
      addORUpdateVisible1: false,
      addORUpdateVisible: false,
      tableData: [],
    };
  },

  created() {
    this.getOpLogisticsList();
  },
  methods: {
    // 禁用

    jingyong() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }

      this.ruleForm = this.tableSelection[0];

      this.$confirm("确认要禁用该物流吗, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.activitymsg
            .enableLogistics({
              logisticId: this.ruleForm.logisticsId,
              state: 2,
            })
            .then((e) => {
              if (e.code == 200) {
                this.$message({
                  message: "禁用成功",
                  type: "success",
                });

                this.getOpLogisticsList();
              } else {
                this.$message.error(e.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //   启用
    cing() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }

      this.ruleForm = this.tableSelection[0];

      this.$api.activitymsg
        .enableLogistics({
          logisticId: this.ruleForm.logisticsId,
          state: 1,
        })
        .then((e) => {
          if (e.code == 200) {
            this.$message({
              message: "启用成功",
              type: "success",
            });

            this.getOpLogisticsList();
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    gteditLogistics() {
      this.$api.activitymsg
        .editLogistics({
          contactsName: this.ruleForm.contactsName,
          contactsPhone: this.ruleForm.contactsPhone,
          logisticsName: this.ruleForm.logisticsName,
          remark: this.ruleForm.remark,
          logisticId: this.ruleForm.logisticsId,
        })
        .then((e) => {
          if (e.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.addORUpdateVisible = false;

            this.getOpLogisticsList();
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    tableSelectionChange(val) {
      this.tableSelection = val;
    },

    update() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }

      this.ruleForm = this.tableSelection[0];
      // 深拷贝
     this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))   

      console.log(this.ruleForm);

      this.addORUpdateVisible = true;
    },

    getang(){
            this.ruleForm={}
    },

    checkClue() {
      this.$api.activitymsg
        .addLogistics({
          contactsName: this.ruleForm.contactsName,
          contactsPhone: this.ruleForm.contactsPhone,
          logisticsName: this.ruleForm.logisticsName,
          remark: this.ruleForm.remark,
        })
        .then((e) => {
          if (e.code == 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });

            this.ruleForm={},

            (this.addORUpdateVisible2 = false), this.getOpLogisticsList();
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },

    add() {
      this.addORUpdateVisible2 = true;
    },

    getOpLogisticsList() {
      this.$api.activitymsg.getOpLogisticsList({}).then((e) => {
        this.tableData = e.data;
      });
    },

    getchakxq(txt) {
      this.ruleForm = txt;
      this.addORUpdateVisible1 = true;
    },
  },
};
</script>

<style scoped>
.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ax1 {
  height: 30px;
}

.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
